module.exports = __webpack_public_path__ + "static/12-multizone-network-design-593a9e681e976fa0d37ce7fd644eae78.jpg";